import useBasketRecommendations from '~/services/loop54/hooks/useBasketRecommendations';
import { reduceLoop54Product } from '~/services/loop54/utils';

export default function useBasketRecommendationsResults(productIds: string[]) {
    return useBasketRecommendations(
        {
            entities: productIds.map((id) => ({
                type: 'Product',
                id,
            })),
            resultsOptions: {
                sortBy: [{ type: 'popularity' }],
                take: 10,
            },
        },
        (data) => ({
            ...data,
            results: reduceLoop54Product(data.results),
        }),
    );
}
